export default __webpack_public_path__ + "static/media/logo.54b18dd3.svg";